module.exports = __webpack_public_path__ + "media/images/emblems/Niederhasli-blazon-side-34e5f18cf3063568f47d40e630f828d1.svg";